import { c as _c } from "react/compiler-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { get } from 'lodash';
import { useMemo } from 'react';
import useSWR, { type SWRResponse } from 'swr';
import { useUseApiCommonLogic } from '../common';
import type { DemoData, UseApiOptions } from '../types';
import TypedApi, { type ApiFetcher, type ApiParams, type ApiPaths, type ApiReturnType, ApiRouteNames } from 'src/app/api';
function useApi(path, params, options, _demoData) {
  const $ = _c(14);
  const {
    middleware,
    skip,
    intervalMs,
    fetchOptionsRef
  } = useUseApiCommonLogic(options);
  let t0;
  if ($[0] !== params || $[1] !== path || $[2] !== skip) {
    t0 = skip ? null : {
      url: path,
      args: params
    };
    $[0] = params;
    $[1] = path;
    $[2] = skip;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const args = t0;
  options?.pathNameOnly;
  let t1;
  if ($[4] !== fetchOptionsRef || $[5] !== options?.pathNameOnly || $[6] !== path) {
    t1 = async t2 => {
      const {
        args: params_0
      } = t2;
      return (await (get(TypedApi, path) as ApiFetcher<TPath>)(params_0, options?.pathNameOnly ?? true, fetchOptionsRef.current)) as ApiReturnType<TPath>;
    };
    $[4] = fetchOptionsRef;
    $[5] = options?.pathNameOnly;
    $[6] = path;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const api = t1;
  let t2;
  if ($[8] !== middleware) {
    t2 = [middleware];
    $[8] = middleware;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const t3 = options?.keepPreviousData;
  let t4;
  if ($[10] !== intervalMs || $[11] !== t2 || $[12] !== t3) {
    t4 = {
      refreshInterval: intervalMs,
      use: t2,
      keepPreviousData: t3
    };
    $[10] = intervalMs;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return useSWR(args, api, t4) as Pick<SWRResponse<TSelection, Error, any>, 'data' | 'isLoading' | 'error' | 'isValidating'>;
}

/** @ts-expect-error - This is a workaround to satisfy the type checker */
const _ = useApi satisfies BaseUseApiHook;
export { ApiRouteNames };
export default useApi;